import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FormHelperModule } from '../form/form-hepler.module';
import { ImageUploadModule, SharedModule } from '../shared.module';
import { InfoMapComponent } from './info-map/info-map.component';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { PageBreadcrumbComponent } from './page-breadcrumb/page-breadcrumb.component';
import { PageLoaderComponent } from './page-loader/page-loader.component';
import { BrowseStaffWidgetsComponent } from './tab-head/browse-staff-widgets/browse-staff-widgets.component';
import { TabHeadComponent } from './tab-head/tab-head.component';
import { DentalChartRefComponent } from './dental-chart-ref/dental-chart-ref.component';
import { SendMsgComponent } from './send-msg/send-msg.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PrintDocComponent } from './print-doc/print-doc.component';


@NgModule({
  declarations: [
    InfoMapComponent,
    PageBreadcrumbComponent,
    PageLoaderComponent,
    InfoModalComponent,
    TabHeadComponent,
    BrowseStaffWidgetsComponent,
    DentalChartRefComponent,
    SendMsgComponent,
    PrintDocComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormHelperModule,
    ImageUploadModule,
    SharedModule,
    OverlayPanelModule
  ],
  exports: [InfoMapComponent, PageBreadcrumbComponent, PageLoaderComponent,
    TabHeadComponent, BrowseStaffWidgetsComponent, DentalChartRefComponent,PrintDocComponent]
})
export class FeatureModalModule { }
